export default "__VITE_PUBLIC_ASSET__ddcaaba0__"